import type { Translate } from "./chatbotManagement.types";

export const formatNumber = (value: number | undefined): string =>
  new Intl.NumberFormat().format(value || 0);

export const formatCost = (value: number | undefined): string =>
  `$${Number(value || 0).toFixed(4)}`;

export const formatSummaryCost = (value: number | undefined): string =>
  `$${Number(value || 0).toFixed(2)}`;

export const formatCompact = (value: number | undefined): string =>
  new Intl.NumberFormat(undefined, {
    notation: "compact",
    maximumFractionDigits: 2,
  }).format(value || 0);

export const formatDate = (value: string | null | undefined, t: Translate): string =>
  value ? new Date(value).toLocaleString() : t("admin_chatbot_never");

export const usagePercentage = (used: number | undefined, limit: number | undefined): number =>
  (limit || 0) > 0
    ? Math.min(100, Math.max(0, Math.round(((used || 0) / (limit || 0)) * 100)))
    : 0;

export const progressColor = (percentage: number): string => {
  if (percentage >= 80) return "#dc3545";
  if (percentage >= 50) return "#f0ad1f";
  return "#65a824";
};
